var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 1.02441H6.4C2.86538 1.02441 0 3.88979 0 7.42441V24.5751C0 28.1098 2.86538 30.9751 6.4 30.9751H25.6C29.1346 30.9751 32 28.1098 32 24.5751V7.42441C32 3.88979 29.1346 1.02441 25.6 1.02441Z",
    fill: "#520A76"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_256_561",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 20,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6004 7.01514H6.40039V24.9856H25.6004V7.01514Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_256_561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4472 7.01514L13.8601 16.9269L6.40039 24.9856H8.07928L14.6102 17.9301L19.8875 24.9856H25.6008L17.7704 14.5165L24.7139 7.01514H23.035L17.0203 13.5131L12.1605 7.01514H6.4472ZM8.91613 8.25181H11.5408L23.1311 23.7487H20.5064L8.91613 8.25181Z",
    fill: "#F2F2F7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.6668ea93ae4617854bc91ea0ea2d7e17.svg";
export { ForwardRef as ReactComponent };